
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useRole } from "@/hooks/useRole";
import { useAuth } from "@/hooks/useAuth";
import { logger } from '@/utils/logger';

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { role, loading: roleLoading } = useRole();
  const { user, loading: authLoading } = useAuth();
  
  logger.debug("AdminGuard: user:", user, "role:", role, "authLoading:", authLoading, "roleLoading:", roleLoading);

  if (authLoading || roleLoading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-pulse text-center">
        <p className="text-muted-foreground">Loading permissions...</p>
      </div>
    </div>;
  }

  if (!user) {
    return <Navigate to="/auth" />;
  }

  if (role !== 'admin') {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
